export default __webpack_public_path__ + "static/media/arrow-right-blue.167c2fa7.svg";